import React from 'react';
import { GoTo } from 'Components/molecules/GoTo';

export const getGoTo = (url, title) => (
  <GoTo
    title={title}
    url={url}
    label="Go to"
    icon="polaris__ico-next"
    defaultLabel="Go to"
    defualtIcon="polaris__ico-next"
    direction="prev"
    directions={
        {
          next: {
            label: 'Go to',
            icon: 'ico-next',
          },
          prev: {
            label: 'Go back to',
            icon: 'ico-previous',
          },
        }
    }
  />
);
